import * as React from 'react';

/** Shared illustrative Quillstack identity, used in previews and the hero. */
export function AccountMark({
  large = false
}: {
  large?: boolean;
}): React.JSX.Element {
  return (
    <span
      className={`grid shrink-0 place-items-center border border-teal-500/20 bg-[color:var(--accent-darker)] text-[color:var(--mint)] ${large ? 'size-14 rounded-[16px] shadow-[0_0_0_7px_rgba(36,166,137,0.065),0_8px_18px_rgba(0,62,47,0.1)]' : 'size-8 rounded-[9px]'}`}
    >
      <svg
        aria-hidden
        viewBox="0 0 24 24"
        className={large ? 'size-7' : 'size-[18px]'}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m4 8 8-4 8 4-8 4-8-4Z M4 12l8 4 8-4 M4 16l8 4 8-4" />
      </svg>
    </span>
  );
}
